import {Component, OnInit} from '@angular/core';
import {VRGroupService} from '../vrgroup.service';
import {WebsocketMessage} from '../../../shared/websocket/websocketMessage';
import {MapElement} from '../../../shared/map/map-element.model';
import {Point} from 'geojson';
import {StateService} from '../../../shared/state/state.service';
import {RunningTrain, TrainMarker, EquipmentTrain} from '../common/train';
import {Layer} from '../../../shared/map/layer/layer.model';
import {groupBy} from 'lodash-es';
import { AppStabilityService } from '../../../shared/app-stability.service';
import { MapService } from '../../../shared/map/map.service';

@Component({
  selector: 'qm-vrgroup-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class VrBaseComponent implements OnInit {

  private currentTrainId: string;
  private previousWebsocketMessage: RunningTrain[];

  constructor(private vrGroupService: VRGroupService,
              private mapService: MapService,
              private stateService: StateService,
              private appStability: AppStabilityService) {
    console.log('Construct VR Base Component');
  }

  async ngOnInit() {
    console.log('NgonInit');

    const initialize = () => {
      console.log('App is stable, initializing VRGroupService');
      this.vrGroupService.init();

      this.vrGroupService.runningTrainData$
        .subscribe((data) => {
          this.handleTrainData(data);
        });
      this.vrGroupService.equipmentData$.subscribe(data => {
        // console.log('hmm data.body', data);
        if (data && data.type === 'geojson') {
          const screenMode = this.stateService.getPartOfState('settingsState').screenMode;
          const equipmentMarkers: MapElement<Point>[] = [];
          const kalustoMap = groupBy(data.body as EquipmentTrain[], 'title');
          const avaimet = Array.from(Object.keys(kalustoMap));
          if (avaimet) {
            for (const key of avaimet) {
              for (const feature of kalustoMap[key]) {
                if (feature.x === 0 || feature.y === 0) {
                  continue;
                }
                feature.direction = feature.bearing - this.mapService.getBearing() - 45;
                feature.markerContainerClass = 'train-marker';
                feature.markerIconClass = 'train-marker-icon';
                feature.markerTitleClass = 'train-marker-content';
                feature.status = 'success';
                this.setFeatureStatus(feature, screenMode);
                feature.markerTitleClass += '-80';
                if (feature.velocity > 1) {
                  feature.markerIconClass += ' has-direction';
                } else {
                  feature.direction = 45;
                }
                if (feature._id === this.currentTrainId) {
                  feature.markerContainerClass += ' selected-marker';
                }
                const layer = this.vrGroupService.getEquipmentLayer(feature);
                equipmentMarkers.push(new MapElement<Point>(feature._id, layer, feature, feature.type, {
                  type: 'Point',
                  coordinates: [feature.x, feature.y]
                }));
              }
            }
          }
          this.addMarkers(equipmentMarkers);
        }
      });
    };
    this.appStability.whenFirstStable().then(() => initialize());
  }


  /**
   * Handler for websocket messages. If websocket contains map data, draw data to map.
   * @param {WebsocketMessage} data
   */
  private handleTrainData(data: RunningTrain[]) {
    // console.log('SEARCH FOR', this.currentTrainTitle);
    const screenMode = this.stateService.getPartOfState('settingsState').screenMode;
    const time = new Date().getTime();
    this.previousWebsocketMessage = data;
    const junaMap = groupBy(data, 'type');
    const avaimet = Array.from(Object.keys(junaMap));
    const trainMarkers: MapElement<Point>[] = [];

    if (avaimet) {
      for (const key of avaimet) {
        for (const feature of junaMap[key]) {
          const marker: TrainMarker = {} as any;
          Object.assign(marker, feature);
          if (feature.x === 0 || feature.y === 0) {
            continue;
          }
          marker.direction = feature.bearing - this.mapService.getBearing() - 45;
          marker.markerContainerClass = 'train-marker';
          marker.markerIconClass = 'train-marker-icon';
          marker.markerTitleClass = 'train-marker-content';
          this.setFeatureStatus(marker, screenMode);
          const diff = (time - new Date(feature.createdAt).getTime()) / 1000;
          if (diff > 120) {
            marker.markerIconClass += ' connection-lost';
            if (diff > 900) {
              marker.markerTitleClass += '-20';
            } else if (diff > 780) {
              marker.markerTitleClass += '-30';
            } else if (diff > 660) {
              marker.markerTitleClass += '-40';
            } else if (diff > 540) {
              marker.markerTitleClass += '-50';
            } else if (diff > 420) {
              marker.markerTitleClass += '-60';
            } else if (diff > 300) {
              marker.markerTitleClass += '-70';
            } else if (diff > 180) {
              marker.markerTitleClass += '-80';
            } else {
              marker.markerTitleClass += '-80';
            }
          } else {
            marker.markerTitleClass += '-80';
          }
          if (feature.velocity > 1) {
            marker.markerIconClass += ' has-direction';
          } else {
            marker.direction = 45;
          }
          if (feature._id === this.currentTrainId) {
            marker.markerContainerClass += ' selected-marker';
          }
          if (feature) {
            const layer = this.vrGroupService.getTrainLayer(feature);
            trainMarkers.push(new MapElement<Point>(marker._id, layer, marker, marker.type, {
              type: 'Point',
              coordinates: [marker.x, marker.y]
            }));
          }
        }
      }
    }
    this.addMarkers(trainMarkers);
  }

  private addMarkers(trainMarkers: MapElement<Point>[]) {
    const map = new Map<Layer, MapElement<Point>[]>();
    trainMarkers.forEach(marker => {
      if (!marker.layer) {
        console.log(marker);
        return;
      }
      const key = marker.layer;
      if (map.has(key)) {
        map.get(key).push(marker);
      } else {
        map.set(key, [marker]);
      }
    });
    map.forEach((markers, layer) => {
      console.log('Push', markers.length,'markers to ', layer.name);
      layer.pushFeatures(markers);
    });
  }

  private setFeatureStatus(feature: TrainMarker, screenMode: number) {
    if (screenMode > 0) {
      feature.markerContainerClass = 'train-marker-special';
      feature.markerIconClass = 'train-marker-icon-special';
      feature.markerTitleClass = 'train-marker-content-special';
    } else {
      feature.markerContainerClass = 'train-marker';
      feature.markerIconClass = 'train-marker-icon';
      feature.markerTitleClass = 'train-marker-content';
    }
    feature.markerContainerClass += ' ' + feature.status;
    feature.markerIconClass += ' ' + feature.status;
    feature.markerTitleClass += ' ' + feature.status;
  }
}
